export const calculateEtaSeconds = (
    startedAt: number,
    completedItems: number,
    totalItems: number | null,
): number | null => {
    if (!totalItems || totalItems <= 0 || completedItems <= 0) {
        return null;
    }

    if (completedItems >= totalItems) {
        return 0;
    }

    const elapsedMs = Date.now() - startedAt;
    if (elapsedMs <= 0) {
        return null;
    }

    const itemsPerMs = completedItems / elapsedMs;
    if (!Number.isFinite(itemsPerMs) || itemsPerMs <= 0) {
        return null;
    }

    const remainingItems = totalItems - completedItems;
    return Math.max(1, Math.round(remainingItems / itemsPerMs / 1000));
};
